<template>
    <div class="xmhbView">
        <img :src="png1" />
        <img :src="png2" @click="goTarget()" />
        <img :src="png3" />
    </div>
</template>

<script>
import png1 from '@/assets/huibao/1.png';
import png2 from '@/assets/huibao/2.png';
import png3 from '@/assets/huibao/3.png';

export default {
    data(){
        return{
            png1:png1,
            png2:png2,
            png3:png3
        }
    },
    methods:{
        goTarget(){
            window.location.href='http://act.tk.cn/channel/nprd/livelihood-policy-query/#/';
        }
    }
}
</script>

<style lang="less" scoped>

.xmhbView{
    width: 100%;
    img{
        width: 100%;
        vertical-align: middle;
        display: block;
    }
}


</style>